import { Component, Input } from '@angular/core';
import { FileApiService } from 'src/app/services/api/file-api.service';

@Component({
  selector: 'app-image',
  templateUrl: './image.component.html',
  styleUrls: ['./image.component.scss'],
})
export class ImageComponent {
  @Input() fileid: string = '';
  @Input() width: string = 'auto';
  @Input() height: string = 'auto';
  @Input() radius = 0;
  constructor(private api: FileApiService) {}

  url(): string {
    if (!this.fileid) {
      return '';
    }
    return this.api.fileurl(this.fileid);
  }

  style() {
    return {
      // width: this.width,
      // height: this.height,
      'border-radius': this.radius + 'px',
      'background-image': 'url(' + this.url() + ')',
      'background-size': 'cover',
      'background-repeat': 'no-repeat',
      'background-position': 'center',
    };
  }
}
